import {Component, Input} from '@angular/core';
import {Notification} from '../../../models/notification/notification';
import {NotificationService} from '../../../services/notification.service';

@Component({
    selector: 'lv-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.scss'],
    standalone: false
})
export class NotificationItemComponent {
  @Input()
  notificationItem: Notification;
  @Input()
  notificationId: number;
  constructor(private _notificationService: NotificationService) {
  }
  public closeClicked(): void {
    this._notificationService.removeNotification(this.notificationId);
  }
}
